import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import Loading from "../../../ui/loading/Loading";
import {api} from "../../../../api/api";
import {none, Option, option} from "ts-option";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import AssetHistory from "../../../../model/asset/AssetHistory";
import AssetHistoryTable from "../AssetHistoryTable";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {RootState} from "../../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import AssetCategory from "../../../../model/asset/AssetCategory";

interface ComponentProps {
	/**
	 * Asset object
	 */
	assetId: string;
	/**
	 * On close.
	 */
	onClose: () => void;
}

interface ReduxProps {
	/**
	 * Assets categories list.
	 */
	assetCategories: AssetCategory[]
}

interface State {
	/**
	 * Asset history list
	 */
	assetHistory: Option<AssetHistory[]>;
	/**
	 * Indicates if history data is loading.
	 */
	isLoading: boolean;
}

type Props = ComponentProps & ReduxProps

class AssetHistoryModal extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			assetHistory: none,
			isLoading: true
		};
	}

	componentDidMount() {
		api.instance.assetApi.fetchAssetHistory(this.props.assetId)
			.then(aHistory => this.setState({assetHistory: option(aHistory), isLoading: false}))
			.catch((e) => {
				this.props.onClose();
				notifyBugsnagAndShowToast(e, "Fetch asset history");
			});
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose}
				   title={"Asset history"}>
				<Loading isLoading={this.state.isLoading}>
					<AssetHistoryTable assetHistory={this.state.assetHistory}
									   assetsCategories={this.props.assetCategories}/>
					<div style={{float: "right", marginBottom: "24px"}}>
						<ButtonPrimary onClick={this.props.onClose}
									   label={"Close"}/>
					</div>
				</Loading>
			</Modal>
		)
	}
}

function mapStateToProps(state: RootState) {
	return {
		assetCategories: state.assetCategory.assetCategories.getOrElse([])
	}
}

export default connect<ReduxProps, null, ComponentProps>(mapStateToProps)(AssetHistoryModal)


